import './loading.scss';
import PropTypes from 'prop-types';
import React from 'react';

export const Loading = ({ message }) => (
    <div className="loading">
        <div>
            <div className="indicator">
                <div className="lds-roller">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
            <div className="message">{ message }</div>
        </div>
    </div>
);

Loading.propTypes = {
    message: PropTypes.string,
};
